import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e16baf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-16" }
const _hoisted_2 = { class: "bold item-header" }
const _hoisted_3 = { class: "bold view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      justify: "space-between",
      align: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createElementVNode("h5", _hoisted_2, [
              _renderSlot(_ctx.$slots, "title", {}, undefined, true)
            ])
          ]),
          _: 3
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("h5", _hoisted_3, [
              _renderSlot(_ctx.$slots, "control", {}, undefined, true)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    _renderSlot(_ctx.$slots, "main", {}, undefined, true)
  ]))
}